import React from 'react';
import PropTypes from "prop-types";

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { BootstrapDialog } from "components/Elements/Dialog/common"
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import ClubEditor from './Editor';



const ClubEditorDialog = ({ open, close, cardroom, union, club, clubs, onClubUpdated }) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md')); //size at which dialog goes full screen

    return <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth="lg">
        <DialogTitle sx={{ m: 0, p: 2 }} style={{ backgroundColor: theme.palette.secondary.main }}>
            <SoftBox>
                <SoftTypography variant="h6" color="white" textTransform="capitalize" opacity={0.7}>
                    Club Editor: {club ? club.name : null}
                </SoftTypography>
            </SoftBox>
        </DialogTitle>
        <DialogContent dividers>
            <SoftBox mt={3}>
                <ClubEditor cardroom={cardroom} club={club} union={union} onClose={close} clubs={clubs} onClubUpdated={onClubUpdated} />
            </SoftBox>
        </DialogContent>
    </BootstrapDialog>;
}

ClubEditorDialog.defaultProps = {

};

ClubEditorDialog.propTypes = {
    cardroom: PropTypes.object.isRequired,
    union: PropTypes.object.isRequired,
    club: PropTypes.object.isRequired,
    onClubUpdated: PropTypes.func
};

export default ClubEditorDialog;
